<template>
    <CollapsibleWidget v-if="options.length > 0">
        <template #name>Master Template Type</template>

        <template #controls />

        <CheckboxGroup v-model="selectedValues" class="editable-group__values" :vertical="true">
            <Checkbox v-for="option in options" :key="option" :label="option" />
        </CheckboxGroup>
    </CollapsibleWidget>
</template>

<script lang="ts">
import { TemplateType } from "hoxton-shared/enums/masterTemplate";
import { defineComponent, type PropType } from "vue";
import { deepClone } from "@/utils";
import { FilterType, MasterTemplateLibraryAction } from "@/store/modules/masterTemplateLibrary";
import CollapsibleWidget from "@/components/Campaign/widgets/CollapsibleWidget.vue";

export default defineComponent({
    name: "MasterTemplateTypeFilter",
    components: { CollapsibleWidget },

    props: {
        campaignMasterTemplateIds: {
            type: Array as PropType<string[]>,
            default() {
                return [];
            }
        }
    },

    computed: {
        filterValues() {
            return this.$store.state.masterTemplateLibrary.filters.filter(filter => filter.type === FilterType.Type);
        },

        options() {
            return Object.values(TemplateType);
        },

        selectedValues: {
            get() {
                if (this.filterValues.length) {
                    const filterValuesCopy = deepClone(this.filterValues);

                    return filterValuesCopy.pop()?.values;
                }

                return [];
            },
            set(newValue: string[]) {
                this.$store.dispatch(MasterTemplateLibraryAction.UpdateTypeFilter, {
                    values: newValue
                });
            }
        }
    },

    beforeUnmount() {
        this.selectedValues = [];
    }
});
</script>

<style lang="scss">
.editable-group {
    .show-form--showing {
        display: none;
    }
}

.editable-group__add {
    width: 100%;
}

.editable-group__values {
    width: 100%;
}
</style>
